module.exports = __webpack_public_path__ + "static/media/footer_btn_send_focused.b53b2d3f.svg";